import classNames from "classnames";
import { TooltipWrapper } from "../../../components/tooltip/TooltipWrapper";
import styles from "./RationaleMark.module.css";

// Marks a report whose underwriting rationale has been written. Same icon as
// the rationale button on the report page.
export const RationaleMark = () => {
  return (
    <TooltipWrapper tooltipText="Underwriting rationale on file">
      <i className={classNames("pi pi-pen-to-square", styles.mark)} />
    </TooltipWrapper>
  );
};
